export default {
    props: {
        schemaModel: {
            type: Object,
            kComposite: 'schema.model'
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-datasource-vue-wrapper/src/KendoGanttDataSource/Schema.js